<script>
  import resources from './resources'

  export default {
    name: 'gadget-active-agenda',
    mixins: [resources]
  }
</script>

<template lang="pug">
  section.gadget-agenda-ativa.white-bg.wrapper.full-width.gadget
    .gadget-title
      | Agenda Ativa
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .col-md-12
      label.light-red Identificação da Agenda
      f-select-professional-agenda(
        v-model="agenda_id", :parameters="{active: true}", :get-all="true", :searchable="false", @received="setFirstAgenda", @selected="selectedAgenda")
    .clearfix
    div(style='margin-top:15px;')
      .col-xs-12.col-sm-4.col-md-3(v-if="false")
        label.light-red Dia da Semana
        h4.medium-gray Seg-Qua-Sex
      .col-xs-12.col-sm-4.col-md-3(v-if="false")
        label.light-red Período de Atendimento
        h4.medium-gray 8h - 12h | 14h - 16h
      .col-xs-12.col-sm-4.col-md-2(v-if="false")
        label.light-red
          | Intervalo
          small (minutos)
        h4.medium-gray 30
      .col-xs-12.col-md-4(v-if="false")
        label.light-red Situação da Agenda
        .percentage-graph
          // Base
          .base
            .text 25% Preenchida
          // Cor
          .color(style='width:25%;')
            .text
              | 25% Preenchida
    .clearfix
    div(style='margin-top:15px;')
      .col-xs-12.col-sm-6.col-md-3
        label.light-red Unidade de Atendimento
        h4.medium-gray {{ agenda.address.name }}
      .col-xs-12.col-sm-6.col-md-9
        label.light-red Localização
        h4.medium-gray {{ agenda.address.label }} - {{ agenda.address.label2 }}
    div
      .table.col-xs-12
        .row.hidden-xs.hidden-sm
          .col-xs-12.col-sm-2.col-title.active Hora
          .col-xs-12.col-sm-4.col-title Paciente
          .col-xs-12.col-sm-4.col-title Convênio
          .col-xs-12.col-sm-2.col-title Status
        .order-by.hidden-md.hidden-lg
          | Ordenar por
          span
            select.ordenar-por(name='Ordenar por')
              option(value='Hora') Hora
              option(value='Paciente') Paciente
              option(value='Convênio') Convênio
              option(value='Status Atendimento') Status
        ul.row
          li(v-for="schedule in agenda.schedules")
            .col-xs-12.col-sm-2.title
              | {{ schedule.time }}
            .col-xs-12.col-sm-4
              |  {{ schedule.patient }}
            .col-xs-12.col-sm-4
              | {{ schedule.covenant }}
            .col-xs-12.col-sm-2
              | {{ schedule.status }}
            .clearfix
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/active-agenda/active-agenda.vue